'use strict';

frontendApp.controller('ConfirmModalCtrl', ['$scope', '$uibModalInstance', 'title', 'message', function($scope, $uibModalInstance, title, message) {

    $scope.title = title;
    $scope.message = message;
    
    $scope.cancel = function() {
        $uibModalInstance.dismiss();
    };

    $scope.ok = function() {
        $uibModalInstance.close('ok');
    };

}]);
    
